import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import logo1 from "../../assets/images/logo/logo-white.png";
import "../../index.css";
import { LoginSchema } from "../Components/Schemes/LoginScheme";
import showEye from "../../assets/images/logo/showEye.svg";
import hideEye from "../../assets/images/logo/hideEye.svg";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import routes from "../Components/data/remote/Routes";
import { Puff } from "react-loader-spinner";

const notify = (message, type) => {
  // alert('error', +message)
  type == "success"
    ? toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        closeButton: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      })
    : toast.error(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        closeButton: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",

        style: {
          backgroundColor: "#D92533",
        },
      });
};

const Login = () => {
  const initialValues = {
    email: "",
    password: "",
  };
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };
  const history = useNavigate();

  const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
    useFormik({
      initialValues,
      validationSchema: LoginSchema,
      validateOnChange: true,
      validateOnBlur: false,
      onSubmit: (values, action) => {
        setLoading(true);
        secureLocalStorage.setItem("email", values.email);
        //Calling Login Api
        var formdata = new FormData();
        formdata.append("email", values.email);
        formdata.append("password", values.password);

        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };

        fetch(routes.LOGIN, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status == true) {
              // console.log(result);
              history("/home");
              secureLocalStorage.setItem("token", result.token);
              secureLocalStorage.setItem("id", result.user?.id);
              secureLocalStorage.setItem("image", result.user?.image);
              secureLocalStorage.setItem(
                "contact_number",
                result.user?.contact_number
              );
              secureLocalStorage.setItem("email", result?.user?.email);
              secureLocalStorage.setItem(
                "employment_number",
                result?.user?.employment_number
              );
              secureLocalStorage.setItem(
                "first_name",
                result?.user?.first_name
              );
              secureLocalStorage.setItem("last_name", result?.user?.last_name);
              secureLocalStorage.setItem("userLevel", result?.user?.id);

              notify("Login successful", "success");
              setLoading(false);
            } else {
              notify(result.message, "error");
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log("error", error);
            setLoading(false);
          });
      },
    });
  useEffect(() => {
    const getToken = secureLocalStorage.getItem("token");
    if (getToken) {
      history("/home");
    } else {
      history("/");
    }
  }, []);
  return (
    <div className="container-fluid loginpage">
      <ToastContainer />
      {loading && (
        <div className="loaderScreen">
          <Puff
            height={80}
            width={120}
            color="rgba(0, 120, 207, 1)"
            ariaLabel="puff-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}
      <div className="col-sd-3 col-md-6 col-lg-4  container card card-login d-flex justify-content-center">
        <div
          style={{
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div style={{ width: "50%" }}>
            <img src={logo1} className=" " alt="..." />
          </div>
        </div>
        <h5 className="card-title">AL Asab</h5>
        <form
          onSubmit={handleSubmit}
          className="card-body card-body-login"
          noValidate
        >
          <div className="login-text-area ">
            <label for="validationDefaultEmail" className="form-label">
              <strong className="login-text">Email </strong>
            </label>
            <input
              type="email"
              className="form-control loginEmailInput"
              id="validationDefaultEmail"
              placeholder="Your Email"
              required
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.email && touched.email ? (
              <p className="form-error">{errors.email}</p>
            ) : null}
          </div>

          <div className="login-text-area">
            <div className="loginText">
              <div>
                <strong className="login-text">PASSWORD </strong>
              </div>

              <div>
                <Link to={"/forget-password"}>
                  <strong className="login-forget-text">
                    Forget Password ?{" "}
                  </strong>
                </Link>
              </div>
            </div>
            <div className="forgetInputs">
              <input
                type={isPasswordVisible ? "text" : "password"}
                className="form-control loginPasswordInput"
                id="exampleFormControlInput1"
                name="password"
                placeholder="Password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <div
                className="eyeButtonLogin"
                onClick={togglePasswordVisibility}
              >
                {isPasswordVisible ? (
                  <img width={20} src={showEye} />
                ) : (
                  <img width={20} src={hideEye} />
                )}
              </div>
              {errors.password && touched.password ? (
                <p className="form-error">{errors.password}</p>
              ) : null}
            </div>
          </div>

          <button className="login-button mt-4" type="submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
